import React, { useState, useEffect } from "react";

import PropTypes from "prop-types";

import { Grid, Box } from "@mui/material";
import { withStyles } from "@mui/styles";
import Carousel from 'react-bootstrap/Carousel'

import styles from "./styles";
import './styles.css';
import project0 from "../../assets/images/home4.jpg";
import project1 from "../../assets/images/mezastarguidepromo.png";
import project2 from "../../assets/images/gaoleguidepromo.png";
import project3 from "../../assets/images/qlassroompromo.png";
import project4 from "../../assets/images/wropromo.png";
import apple from "../../assets/images/apple.png";
import google from "../../assets/images/google.png";

export default function Projects() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [index, setIndex] = useState(0);

  useEffect(() => {
    function handleResize() {
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  // handleResize = (e) => {
  //   this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
  // }

  // componentDidMount() {
  //   window.addEventListener("resize", this.handleResize);
  // }

  // componentWillUnmount() {
  //   window.addEventListener("resize", this.handleResize);
  // }

  return (
    // const { classes } = this.props;

    // return (
    <Box sx={{ flexGrow: 1,marginTop:10 }}>
      <Grid container style={{ backgroundColor: 'black' }}>
        <Carousel style={{ height: "100%", width: "100%" }} interval={null} indicators={false} controls={false}>
          <Carousel.Item style={{ height: "100%", minHeight: "100px", width: "100%" }}>
            <div
              className="d-block"
              style={{
                minWidth: "100%",
                height: windowSize.height / 6,
                minHeight: "100%",
                backgroundImage: `url(${project0})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "top center",
                filter: `blur(2px)`,
                // -webkit-filter: blur(8px);
              }}
            />
            <Carousel.Caption style={{ top: 0, bottom: 0 }}>
              <div style={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                <a href="/projects">
                  <h1 style={{ textAlign: 'center', color: 'white', textShadow: `1px 1px #000` }}><b>&lt;Projects&gt;</b></h1>
                </a>
              </div>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      </Grid>


      <Grid id="MezastarGuide" container style={{}}>
        {(windowSize.width < 960) ? <>
        <Grid size={{ xs: 12, md: 7 }} style={{ minHeight: windowSize.height / 2, alignSelf: 'center', display: 'flex', justifyContent: 'center', flexDirection: 'column', }}>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingRight: (windowSize.width < 960) ? 64 : 128, paddingLeft: (windowSize.width < 960) ? 64 : 128, marginTop: (windowSize.width < 960) ? 64 : 0 }}>
            <h2 style={{ textAlign: "left", alignSelf: 'flex-start', }}><b>MezastarGuide</b></h2>
            <h4 style={{ textAlign: "left", alignSelf: 'flex-start', }}><b>A helper app to simplify the Pokémon MEZASTAR arcade game experience.<br /><br />Users can store and scan their Trainer ID, Support Pokémon, view Tags and find machine locations with this app!</b></h4>
            <h4 style={{ textAlign: "left", alignSelf: (windowSize.width < 960) ? 'center' : 'flex-start', }}><b><br />Download Today!</b></h4>
            <div style={{ display: 'flex', flexDirection: (windowSize.width < 960) ? 'column' : 'row', alignItems: 'center', justifyContent: 'flex-start' }}>
                <a href={'https://apps.apple.com/app/meza-guide/id6443785248'} target="_blank" rel="noreferrer">
                  <img alt="Download on your iOS device!" style={{ objectFit: 'cover', height: 58 }} src={apple} />
                </a>
                <a href={'https://play.google.com/store/apps/details?id=com.tehdrink.MezastarGuide'} target="_blank" rel="noreferrer">
                  <img alt="Download on your Android device!" style={{ objectFit: 'cover', height: 84 }} src={google} />
                </a>
            </div>
          </div>
        </Grid>

        <Grid size={{ xs: 12, md: 5 }} style={{ height: "100%", display: 'flex', alignItems: 'center' }}>
          <div
            className="d-block"
            style={{
              minWidth: "100%",
              height: (windowSize.height / 2 < 501) ? 500 : (windowSize.width < 960) ? windowSize.height / 2 : windowSize.height / 2,
              minHeight: "100%",
              backgroundImage: `url(${project1})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
            }}
          />
        </Grid>

        </> :
          <>
            <Grid size={{ xs: 12, md: 5 }} style={{ height: "100%", display: 'flex', alignItems: 'center' }}>
              <div
                className="d-block"
                style={{
                  minWidth: "100%",
                  height: (windowSize.height / 2 < 501) ? 500 : (windowSize.width < 960) ? windowSize.height / 2 : windowSize.height / 2,
                  minHeight: "100%",
                  backgroundImage: `url(${project1})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center center",
                  marginLeft: 60
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} style={{ minHeight: windowSize.height / 2, alignSelf: 'center', display: 'flex', justifyContent: 'center', flexDirection: 'column', }}>
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingRight: (windowSize.width < 960) ? 64 : 64, paddingLeft: (windowSize.width < 960) ? 64 : 128, marginTop: (windowSize.width < 960) ? 64 : 0 }}>
                <h2 style={{ textAlign: "left", alignSelf: 'flex-start', }}><b>MezastarGuide</b></h2>
                <h4 style={{ textAlign: "left", alignSelf: 'flex-start', }}><b>A helper app to simplify the Pokémon MEZASTAR arcade game experience.<br /><br />Users can store and scan their Trainer ID, Support Pokémon, view Tags and find machine locations with this app!</b></h4>
                <h4 style={{ textAlign: "left", alignSelf: (windowSize.width < 960) ? 'center' : 'flex-start', }}><b><br />Download Today!</b></h4>
                           <div style={{ display: 'flex', flexDirection: (windowSize.width < 960) ? 'column' : 'row', alignItems: 'center', justifyContent: 'flex-start' }}>
                <a href={'https://apps.apple.com/app/meza-guide/id6443785248'} target="_blank" rel="noreferrer">
                  <img alt="Download on your iOS device!" style={{ objectFit: 'cover', height: 58 }} src={apple} />
                </a>
                <a href={'https://play.google.com/store/apps/details?id=com.tehdrink.MezastarGuide'} target="_blank" rel="noreferrer">
                  <img alt="Download on your Android device!" style={{ objectFit: 'cover', height: 84 }} src={google} />
                </a>
              </div>
              </div>

            </Grid>
          </>
        }
      </Grid>


      <Grid id="GaOleGuide" container style={{}}>
        <Grid size={{ xs: 12, md: 7 }} style={{ minHeight: windowSize.height / 2, alignSelf: 'center', display: 'flex', justifyContent: 'center', flexDirection: 'column', }}>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingRight: (windowSize.width < 960) ? 64 : 128, paddingLeft: (windowSize.width < 960) ? 64 : 128, marginTop: (windowSize.width < 960) ? 64 : 0 }}>
            <h2 style={{ textAlign: "left", alignSelf: 'flex-start', }}><b>GaOleGuide</b></h2>
            <h4 style={{ textAlign: "left", alignSelf: 'flex-start', }}><b>A helper app to simplify the Pokémon Ga-Olé arcade game experience.<br /><br />Users can scan aids into the game, find machine locations and more with this app!</b></h4>
            <h4 style={{ textAlign: "left", alignSelf: (windowSize.width < 960) ? 'center' : 'flex-start', }}><b><br />Download Today!</b></h4>
            <div style={{ display: 'flex', flexDirection: (windowSize.width < 960) ? 'column' : 'row', alignItems: 'center', justifyContent: 'flex-start' }}>
              <a href={'https://apps.apple.com/app/oleguide/id1616686003'} target="_blank" rel="noreferrer">
                <img alt="Download on your iOS device!" style={{ objectFit: 'cover', height: 58 }} src={apple} />
              </a>
              <a href={'https://play.google.com/store/apps/details?id=com.tehdrink.GaOleGuide'} target="_blank" rel="noreferrer">
                <img alt="Download on your Android device!" style={{ objectFit: 'cover', height: 84 }} src={google} />
              </a>
            </div>
          </div>
        </Grid>

        <Grid size={{ xs: 12, md: 5 }} style={{ height: "100%", display: 'flex', alignItems: 'center' }}>
          <div
            className="d-block"
            style={{
              minWidth: "100%",
              height: (windowSize.height / 2 < 501) ? 500 : (windowSize.width < 960) ? windowSize.height / 2 : windowSize.height / 2,
              minHeight: "100%",
              backgroundImage: `url(${project2})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
            }}
          />
        </Grid>
      </Grid>
      <Grid id="Qlassroom" container style={{}}>
        {(windowSize.width < 960) ? <>
          <Grid size={{ xs: 12, md: 6 }} style={{ alignSelf: 'center', display: 'flex', justifyContent: 'center', flexDirection: 'column', }}>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingRight: (windowSize.width < 960) ? 64 : 128, paddingLeft: (windowSize.width < 960) ? 64 : 128, marginTop: (windowSize.width < 960) ? 64 : 0, marginBottom: 64 }}>
              <h2 style={{ textAlign: "left", alignSelf: 'flex-start', }}><b>Qlassroom</b></h2>
              <h4 style={{ textAlign: "left", alignSelf: 'flex-start', }}><b>Developed for Apple and Android devices during my Final Year Project to aid in personalised learning.</b></h4>
            </div>
          </Grid>
          <Grid size={{ xs: 12, md: 5 }} style={{ height: "100%", display: 'flex', alignItems: 'center' }}>
            <div
              className="d-block"
              style={{
                minWidth: "100%",
                height: (windowSize.height / 2 < 501) ? 500 : (windowSize.width < 960) ? windowSize.height / 2 : windowSize.height / 2,
                minHeight: "100%",
                backgroundImage: `url(${project3})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
              }}
            />
          </Grid>
        </> :
          <>
            <Grid size={{ xs: 12, md: 5 }} style={{ height: "100%", display: 'flex', alignItems: 'center' }}>
              <div
                className="d-block"
                style={{
                  minWidth: "100%",
                  height: (windowSize.height / 2 < 501) ? 500 : (windowSize.width < 960) ? windowSize.height / 2 : windowSize.height / 2,
                  minHeight: "100%",
                  backgroundImage: `url(${project3})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center center",
                  marginLeft: 30
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} style={{ minHeight: windowSize.height / 2, alignSelf: 'center', display: 'flex', justifyContent: 'center', flexDirection: 'column', }}>
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingRight: (windowSize.width < 960) ? 64 : 128, paddingLeft: (windowSize.width < 960) ? 64 : 128, marginTop: (windowSize.width < 960) ? 64 : 0 }}>
                <h2 style={{ textAlign: "left", alignSelf: 'flex-start', }}><b>Qlassroom</b></h2>
                <h4 style={{ textAlign: "left", alignSelf: 'flex-start', }}><b>Developed for Apple and Android devices during my Final Year Project to aid in personalised learning.</b></h4>
              </div>
            </Grid>
          </>
        }
      </Grid>
      <Grid id="WRO" container style={{}}>
        <Grid size={{ xs: 12, md: 7 }} style={{ alignSelf: 'center', display: 'flex', justifyContent: 'center', flexDirection: 'column', }}>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingRight: (windowSize.width < 960) ? 64 : 128, paddingLeft: (windowSize.width < 960) ? 64 : 128, marginTop: (windowSize.width < 960) ? 64 : 0, marginBottom: 64 }}>
            <h2 style={{ textAlign: "left", alignSelf: 'flex-start', }}><b>WRO 2021 Senior Randomizer</b></h2>
            <h4 style={{ textAlign: "left", alignSelf: 'flex-start', }}><b>A mission randomizer for the World Robot Olympiad 2021 Senior Category</b></h4>
            <a href="/senior" style={{ alignSelf: (windowSize.width < 960) ? 'center' : 'flex-start', }}>
              <h4 style={{ textAlign: "center" }}><b><br />Check it out!</b></h4>
            </a>
          </div>
        </Grid>
        <Grid size={{ xs: 12, md: 5 }} style={{ height: "100%", display: 'flex', alignItems: 'center' }}>
          <div
            className="d-block"
            style={{
              minWidth: "100%",
              height: (windowSize.height / 2 < 501) ? 500 : (windowSize.width < 960) ? windowSize.height / 2 : windowSize.height / 2,
              minHeight: "100%",
              backgroundImage: `url(${project4})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "top center",
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}